import { FC, useEffect } from 'react';
import { Col, Row } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { getDefaultFormatDate } from '../../../common/utils/getFormatDate';
import { OnboardingRequestStatuses } from '../../../common/api/services/OnboardingApi/enums/OnboardingRequestStatuses';
import OnboardingWorkPermitTab from '../../onboardingPageV2/tabs/work-permit-tab/WorkPermitTab';
import OnboardingWorkPermitMessage from '../../../components/info-messages/OnboardingWorkPermitMessage';
import DocumentsViewer from '../components/DocumentsViewer';
import { OnboardingFileKeys } from '../../../common/api/services/HistoryApi/common/OnboardingFileKeys';
import { ROUTER_PATHS } from '../../../navigation/routerPaths';
import { historyApi } from '../../../common/api/services/HistoryApi/historyApi';
import { setActiveFields } from '../../../redux/reducers/onboarding-history/sliceReducer';
import HistoryComponent from '../../onboardingPageV2/history/HistoryComponent';
import { FieldKeys } from '../../../common/api/services/HistoryApi/types/fieldKeys';
import { initialHistoryFields } from '../../onboardingPageV2/constants/initialHistoryFields';

const WorkPermitTab: FC = () => {
    const {
        documentType,
        permitType,
        permitCanton,
        startDate,
        endDate,
        basisOfLegalStay,
        comment,
        documents,
        isReligious,
    } = useAppSelector((state) => state.onboarding.workPermit);
    const dispatch = useAppDispatch();
    const isToConfirm = useAppSelector(
        (state) =>
            state.onboarding.tabStatus[3] === OnboardingRequestStatuses.toConfirm ||
            state.onboarding.tabStatus[3] === OnboardingRequestStatuses.draft
    );
    const isSwissNationality = useAppSelector((state) => state.onboarding.personalInfo.nationality === 'Switzerland');

    useEffect(() => {
        const matchedKey = OnboardingFileKeys.find((item) =>
            Object.keys(item).some((key) => key === ROUTER_PATHS.workPermit)
        );
        if (matchedKey) {
            historyApi
                .getOnboardingActiveFields({
                    userId: 'consultant',
                    keys: matchedKey[ROUTER_PATHS.workPermit],
                })
                .then((resp) => dispatch(setActiveFields(resp.data)));
        }
    }, []);

    if (isToConfirm) {
        return <OnboardingWorkPermitTab />;
    }

    if (isSwissNationality) {
        return (
            <Row>
                <Col span={12}>
                    <OnboardingWorkPermitMessage />
                </Col>
            </Row>
        );
    }

    return (
        <Row className="my-information-tab">
            <Col span={24}>
                <h4>Information</h4>
                <HistoryComponent
                    fieldKey={FieldKeys.workPermit}
                    tabName="Work permit"
                    onChangeArray={[]}
                    shownElements={initialHistoryFields[FieldKeys.workPermit]}
                    isHideTabName
                    disableCondition={isSwissNationality}
                    isView={true}
                />
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <div className="personal-info">
                            <span className="item-label">Religion</span>
                            <span className="item-value">{isReligious ? 'Yes' : 'No'}</span>
                        </div>
                    </Col>
                </Row>
                {/* <Col>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <div className="personal-info">
                <span className="item-label">Document type</span>
                <span className="item-value">{documentType}</span>
              </div>
            </Col>
            <Col span={12}>
              <div className="personal-info">
                <span className="item-label">Permit type</span>
                <span className="item-value">{permitType}</span>
              </div>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <div className="personal-info">
                <span className="item-label">Permit canton</span>
                <span className="item-value">{permitCanton}</span>
              </div>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <div className="personal-info">
                <span className="item-label">Start date</span>
                <span className="item-value">
                  {startDate ? getDefaultFormatDate(startDate) : ''}
                </span>
              </div>
            </Col>
            <Col span={12}>
              <div className="personal-info">
                <span className="item-label">End date</span>
                <span className="item-value">
                  {endDate ? getDefaultFormatDate(endDate) : ''}
                </span>
              </div>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <div className="personal-info">
                <span className="item-label">Basis of legal stay</span>
                <span className="item-value">{basisOfLegalStay}</span>
              </div>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <div className="personal-info">
                <span className="item-label">Comment</span>
                <span className="item-value">{!!comment ? comment : '-'}</span>
              </div>
            </Col>
          </Row>
        </Col>
      </Col>

      <Col span={12}>
        <h4>Documents</h4>

        <DocumentsViewer documents={documents} /> */}
            </Col>
        </Row>
    );
};

export default WorkPermitTab;
